<template>
  <div>
    <slot :ctrl="ctrl" :crud="ctrl.crud"></slot>
  </div>
</template>

<script>
export default {
  props: {
    controller: String,
  },
  data() {
    return {
      ctrl: this.get_controller(this.controller),
    };
  },
};
</script>